'use client'

import NextLink from 'next/link'
import type { ReactNode } from 'react'

import { useOptionalPageAnalytics } from '@/app/context/analytics'
import { NO_APLICA } from '@/app/lib/analytics/constants'
import { slugify } from '@/app/lib/analytics/dataLayer'

import {
  EXPLORA_ANALYTICS_CLICK_SUBTYPE,
  EXPLORA_ANALYTICS_CLICK_TYPE,
  EXPLORA_ANALYTICS_MODULE_NAME,
} from './Explora.constants'

interface ExploraTileProps {
  readonly href: string
  /** Nombre visible de la categoría (`MenuCategory.name`), fuente de `link_text` (slugificado). */
  readonly label: string
  readonly isActive: boolean
  readonly className: string
  readonly children: ReactNode
}

/**
 * Único fragmento `'use client'` de `Explora` — el resto de la sección
 * (resolución de icono/href/`isActive`, `Explora.tsx`) sigue siendo Server
 * Component puro; esta hoja solo añade el `click` (`Menú categorías.csv`) al
 * `<Link>` de cada tile, sin tocar su maquetación.
 */
export function ExploraTile({ href, label, isActive, className, children }: ExploraTileProps) {
  const analytics = useOptionalPageAnalytics()

  function handleClick() {
    analytics?.trackClick({
      click_type: EXPLORA_ANALYTICS_CLICK_TYPE,
      click_subtype: EXPLORA_ANALYTICS_CLICK_SUBTYPE,
      link_text: slugify(label),
      link_url: href,
      link_domain: NO_APLICA,
      module_name: EXPLORA_ANALYTICS_MODULE_NAME,
      module_type: NO_APLICA,
      nav_level: NO_APLICA,
      nav_path: NO_APLICA,
      action_detail: NO_APLICA,
      action_value: NO_APLICA,
      action_context: NO_APLICA,
    })
  }

  return (
    <NextLink
      href={href}
      prefetch={false}
      className={className}
      aria-current={isActive ? 'page' : undefined}
      onClick={handleClick}
    >
      {children}
    </NextLink>
  )
}
